import React, { useState, useEffect } from "react";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import {
  AddIconBlue,
  AddIconGray,
  EditIconDarkGray,
  EditIconGray,
  ImageWithLocationIcon,
  TrashIconGray,
} from "../../../../constant/imagePath";
import { Row, Col, Container } from "react-bootstrap";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon.jsx";
import classes from "./Address.module.css";
import Maps from "../../../Maps";
import { Input } from "../../../../stories/Input/Input";
import { DropDown } from "../../../../stories/DropDown/DropDown";
import AddLocationModal from "../../../Modals/CoachFlow/OnBoarding/AddLocation/AddLocation";
import AddressMobile from "./AddressMobile";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import { AddLocation } from "@mui/icons-material";
import PageProgressBar from "../../../../stories/PageProgressBar/PageProgressBar";
import LocationInput from "../../../../stories/LocationInput/LocationInput";
import { setPersonalData } from "../../../../store/Actions/authAction";
import { useDispatch, useSelector } from "react-redux";
import AddedLocationCard from "../../../../stories/AddedLocationCard/AddedLocationCard";

function AddressDesktop({ stepForwardAndBackward }) {
  const dispatch = useDispatch();
  const getDataFromRedux = useSelector(
    (state) => state.onBoardingReducer.address
  );
  const [venueName, setVenueName] = useState();
  const [address, setAddress] = useState();
  const [locationDetail, setLocationDetail] = useState({});
  const [openAddLocation, setOpenAddLocation] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingData, setEditingData] = useState(null);
  const [coordinate, setCoordinate] = useState({});
  const [locations, setLocations] = useState(
    getDataFromRedux ? getDataFromRedux : []
  );

  function addLocationForModal(data) {
    const newArr = locations?.slice();
    newArr.push(data);
    setLocations(newArr);
  }

  // Edit Location
  function editLocation(data) {
    const newArr = [...locations];
    const index = newArr?.findIndex((item) => item?._id == data?._id);
    newArr[index] = data;
    setLocations(newArr);
    setEditingData(null);
  }
  // Delete Location
  function deleteLocation(e) {
    const newArr = [...locations];
    const index = newArr?.findIndex((item) => item?._id === e._id);
    newArr.splice(index, 1);
    setLocations(newArr);
  }
  function addLocation() {
    const newDoc = {
      _id: Math.floor(Math.random() * 10000),
      venueName,
      address,
      img: ImageWithLocationIcon,
      state: locationDetail?.state,
      city: locationDetail?.city,
      country: locationDetail?.country,
    };
    setLocations((p) => [...p, newDoc]);

    setVenueName("");
    setAddress("");
  }

  // Save And Finish Later
  function saveDataIntoRedux() {
    dispatch(setPersonalData("address", locations));
  }

  console.log({ locations });

  return (
    <div className={classes.address}>
      <div className={classes.progressLine}>
        <PageProgressBar progress={"66.6%"} />
      </div>

      <Row className={`gx-0 ${classes.row}`}>
        <Col md={12}>
          <Container fluid className={classes.innerContainer}>
            <Col md={12} className={`${[classes.saveAndFinish].join(" ")}`}>
              <LinkButtonWithIcon
                text={"Save and Finish Later"}
                customStyle={{
                  color: Colors.neutralShadesOfNero,
                  ...Fonts.b2,
                  lineHeight: "20px",
                }}
                onClick={saveDataIntoRedux}
              />
            </Col>

            <Col md={6}>
              <h3
                style={{
                  ...Fonts.h3,
                  color: Colors.neutralShadesOfNero,
                }}
              >
                Where would you host your lesson?
              </h3>

              <p
                className={classes.oneOnOne}
                style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
              >
                1-on-1 lesson
              </p>
            </Col>
            {locations?.length == 0 && (
              <Col md={12}>
                <Row>
                  <Col md={7} lg={7}>
                    {/* Form Row */}
                    <Col md={12}>
                      <Input
                        label={"Venue Name (Optional)"}
                        state={venueName}
                        setter={setVenueName}
                        placeholder={"Type here.."}
                      />
                    </Col>
                    <Col md={12} className={`${[classes.mt32].join(" ")}`}>
                      <Maps
                        type={"places"}
                        label={"Address"}
                        setAddress={setAddress}
                        placeholder={"Type here.."}
                        setCoordinates={setCoordinate}
                        setPlaceDetail={setLocationDetail}
                      />
                    </Col>
                    {/* City State Zipcode */}
                    <Col md={12} className={`${[classes.mt32].join(" ")}`}>
                      {/* <Row>
                        <Col md={4}>
                          <Input
                            label={"City"}
                            state={locationDetail?.city}
                            disabled={true}
                            placeholder={"City"}
                            customStyle={{ padding: "0px" }}
                          />
                        </Col>
                        <Col md={4}>
                          <Input
                            label={"State"}
                            state={locationDetail?.state}
                            disabled={true}
                            placeholder={"State"}
                            customStyle={{ padding: "0px" }}
                          />
                        </Col>
                        <Col md={4}>
                          <Input
                            label={"Country"}
                            state={locationDetail?.country}
                            disabled={true}
                            placeholder={"Country"}
                            customStyle={{ padding: "0px" }}
                          />
                        </Col>
                      </Row> */}
                    </Col>
                  </Col>
                  <Col md={5} lg={5}>
                    <div className={classes.mapBox}>
                      <Maps location={coordinate} type={"map"} />
                    </div>
                  </Col>
                </Row>
              </Col>
            )}

            {/* Added Locations */}
            <Col md={12} className={classes.mt52}>
              {locations?.map((item) => {
                return (
                  <AddedLocationCard
                    data={item}
                    onDelete={deleteLocation}
                    onEdit={(data) => {
                      const newData = {
                        ...data,
                        // city: locationDetail?.city,
                        // state: locationDetail?.state,
                        // country: locationDetail?.country,
                      };
                      setEditingData(newData);
                      setIsEditing(true);
                    }}
                  />
                );
              })}
            </Col>
            {/* Add Location */}
            <Col md={12}
            //  className={`${[classes.mt32].join(" ")}`}
            >
              <LinkButtonWithIcon
                leftIcon={AddIconBlue}
                text={"Add Location"}
                primary={true}
                disabled={(locations?.length == 0 && address == null) || false}
                iconStyle={{
                  marginRight: "10px",
                }}
                onClick={
                  locations?.length == 0
                    ? () => addLocation()
                    : () => setOpenAddLocation(true)
                }
              />
            </Col>
          </Container>
        </Col>
        {/* Last Col */}
        <Col
          md={12}
          className={classes.btnsCol}
          style={{
            borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
        >
          <div className={classes.btnsBox}>
            <Button
              label={"Back"}
              size={"Large"}
              customStyle={{ width: "162px", height: "56px" }}
              onClick={() => stepForwardAndBackward(2, 1)}
            />
            <Button
              label={"Next"}
              primary={true}
              size={"Large"}
              customStyle={{ width: "162px", height: "56px" }}
              onClick={() => {
                saveDataIntoRedux();
                stepForwardAndBackward(2, 3);
              }}
            />
          </div>
        </Col>
        {openAddLocation && (
          <AddLocationModal
            setShow={setOpenAddLocation}
            show={openAddLocation}
            onAdd={addLocationForModal}
          />
        )}
        {isEditing && (
          <AddLocationModal
            data={editingData}
            setShow={setIsEditing}
            show={isEditing}
            onAdd={editLocation}
            isEditing
          />
        )}
      </Row>
    </div>
  );
}

export default function Address({ stepForwardAndBackward }) {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? (
    <AddressMobile stepForwardAndBackward={stepForwardAndBackward} />
  ) : (
    <AddressDesktop stepForwardAndBackward={stepForwardAndBackward} />
  );
}
